<template>
  <div class="app-footer-phone common-layout">
    <div class="app-footer-content">
      <!-- ★修改：在 manshonRegist / inquary 时，footer logo 不可点击 -->
      <a
        v-if="isLogoClickable"
        class="app-footer-logo"
        @click.prevent="goLoginWithManshonId"
      ></a>
      <span
        v-else
        class="app-footer-logo app-footer-logo--disabled"
        aria-disabled="true"
      ></span>

      <div class="app-footer-list">
        <div class="app-footer-list-minor-wrap">
          <el-dropdown trigger="click" placement="top" @visible-change="clickDropdown">
            <span class="el-dropdown-link">
              <span class="el-dropdown-link-open">{{dropdownIsOpen ? '-' : '+'}}</span> サポートメニュー
            </span>
            <el-dropdown-menu class="app-footer-list-minor" slot="dropdown">
              <el-dropdown-item>
                <a class="app-footer-list-item-minor" href="/privacy.html" target="_blank">個人情報保護方針</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="app-footer-list-item-minor" href="/terms.html" target="_blank">利用規約</a>
              </el-dropdown-item>
              <!-- <el-dropdown-item>
                <a class="app-footer-list-item-minor" href="/disclaimer.html" target="_blank">
                  免責事項
                </a>
              </el-dropdown-item> -->
              <!-- <el-dropdown-item>
                <a class="app-footer-list-item-minor" href="/recommendedBrowser.html" target="_blank">
                  推奨ブラウザ
                </a>
              </el-dropdown-item> -->
              <el-dropdown-item>
                <a class="app-footer-list-item-minor" href="https://www.smapay.co.jp/" target="_blank">運営会社</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <div class="app-footer-copyright">
      <span>Copyright Ⓒ 2026 すまてっく株式会社 All rights Reserved.</span>
    </div>
  </div>
</template>

<script>
import guideImg from '@/assets/guide.png';
import howtoImg from '@/assets/howto.png';
import myPageLogo from '@/assets/user.png';

export default {
  name: 'PhoneFooter',
  data() {
    return {
      guideImg,
      myPageLogo,
      howtoImg,
      dropdownIsOpen: false,
    };
  },
  computed: {
    // ★新增：logo点击可否
    isLogoClickable() {
      const href = window.location.href || '';
      return !(href.indexOf('manshonRegist') !== -1 || href.indexOf('inquary') !== -1);
    },
  },
  methods: {
    clickDropdown(dropdownIsOpen) {
      this.dropdownIsOpen = dropdownIsOpen;
    },
    goLoginWithManshonId() {
      // ★保险：即使误触也不跳转
      const href = window.location.href || '';
      if (href.indexOf('manshonRegist') !== -1 || href.indexOf('inquary') !== -1) return;

      const manshonId = localStorage.getItem('sessionManshonId');
      this.$router.push({ path: '/board', query: { manshonId } });
    },
  },
};
</script>

<style lang="less" scoped>
  .el-footer .app-footer-phone {
    display: none;
    padding: 20px 0;
    flex-direction: column;
    width: 100%;
    color: #0f3264;

    .app-footer-content{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .app-footer-logo {
        width: 200px;
        height: 60px;
        display: block;
        background: url(../assets/wan-nyan-mate_logo_yoko.png) no-repeat;
        background-size: contain;
        background-position: center;
      }

      /* ★新增：不可点击样式 */
      .app-footer-logo--disabled {
        cursor: default;
        pointer-events: none;
        opacity: 0.9;
      }

      .app-footer-list {
        flex: 1;

        .app-footer-list-item-major-wrap {
          display: flex;
          justify-content: space-around;
          margin-bottom: 25px;
          padding: 0 20px;

          .app-footer-list-item-major a {
            display: flex;
            align-items: center;
            color: rgb(15, 51, 100);
            font-weight: bold;
            height: 30px;
            line-height: 30px;

            .el-avatar {
              background-color: transparent;
            }
          }
        }

        .app-footer-list-minor-wrap {
          text-align: center;
          margin-bottom: 15px;

          .el-dropdown-link {
            color: rgb(15, 51, 100);
            border: solid 1px rgb(15, 51, 100);
            border-radius: 4px;
            padding: 8px 20px;

            .el-dropdown-link-open {
              display: inline-block;
              width: 12px;
            }
          }
        }
      }
    }

    .app-footer-copyright {
      margin-top: 5px;
      margin-bottom: 10px;
      text-align: center;

      span {
        vertical-align: middle;
        font-size: 12px;
      }
      .el-link {
        color: #0f3264;

        &:hover {
          color: #409EFF;
        }
      }
    }
  }

  @media (max-width: 767px) {
    #app {
      .el-footer .app-footer-phone {
        display: flex;
      }
    }
  }
</style>
